import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { WefitSsoService } from '../../services/sso/wefit-sso.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-premium-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './premium-modal.component.html',
  styleUrls: ['./premium-modal.component.scss']
})
export class PremiumModalComponent implements OnInit {

  upgradeUrl: string | null = null;

  constructor(
    public activeModal: NgbActiveModal,
    private wefitSsoSrv: WefitSsoService
  ) {}

  async ngOnInit() {
    const [token, ssoUrl] = await Promise.all([
      this.wefitSsoSrv.getToken(),
      this.wefitSsoSrv.getSsoUrl(),
    ]);
    const base = (ssoUrl || environment.wefitEndpoint).replace(/\/$/, '');
    this.upgradeUrl = token ? `${base}?token=${token}` : base;
  }

  openUpgrade() {
    if (this.upgradeUrl) {
      window.location.href = this.upgradeUrl;
    }
    this.activeModal.close();
  }
}
